import React from "react";
import TableMain from "../Common/table/TableMain";
import PointTableFilter from "../Common/table/PointTableFilter";
import { getLastPage } from "../../utils/getLastPage";
import { useTranslation } from "react-i18next";


const PayoutTable = (props) => {
  const { t } = useTranslation();
  
  const headers = [t("Date"),t("username"), t("fromusername"),t("country"), t("personalPV"),t("activePv"),t("leaderPv"),t("guestPv"),t("nonManagerPv"),t("passPv"),t("totalPv"),t("newPv")];
  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);


   


   
  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        <PointTableFilter
          setActiveTab={props.setActiveTab}
          activeTab={props.activeTab}
          headers={headers}
          reportHeader={props.reportHeader}
          data={props.data?.data}
          type={props.type}
          setCurrentPage={props.setCurrentPage}
          setDateRange={props.setDateRange}
          onHandleExport={props.onHandleExport}
         
        />
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props?.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={lastPage}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            setEpinSortOptions={props.setSortOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default PayoutTable;
